<app-gen-button-group
	[disabled]="isUpdateMode || isPastEvent"
	[actualObj]="followupserie"
	fieldName="followuptype_id"
	[options]="followuptypes"
	tabindex="-1"
	optionFieldValue="id"
	(changeEvent)="updFollowuptype()"
	isTab
	class="flex-grow-1"
/>
@if (mrMessage) {
	<div class="mrMessage">{{ mrMessage }}</div>
}

<div
	class="d-flex flex-column patient_contact_meeting_row gap-3"
	[class.is-new-person]="followupserie.is_new_patient_or_contact == 'yes'"
>
	<div
		class="d-flex gap-2 align-items-start"
		style="flex-flow: row wrap"
	>
		@if (isFetchingPatient || patient) {
			<div class="flex-v-center">
				<app-spin-or-content [isSpin]="isFetchingPatient">
					<button
						titleLang="patient"
						class="btn btn-icon"
						tabindex="12"
						(click)="modalProps = { name: 'patient' }"
						icon="patient"
					></button>
					<!--icon="(patient.is_group=='yes'?group:patient)"-->
				</app-spin-or-content>
			</div>
		}
		<div
			class="flex-grow-1"
			[hidden]="
				!(
					followupserie.is_new_patient_or_contact == 'no' &&
					followupserie.meeting_with != 'meeting'
				)
			"
		>
			<div>
				<app-gen-autocomplete
					#personFuzzyInput
					[disabled]="isUpdateMode || isPastEvent"
					title_ph_lang="patient_contact_or_meeting"
					avoidNoResult
					[error]="
						errors[
							followupserie.meeting_with == 'patient'
								? 'patient_id'
								: followupserie.meeting_with == 'user'
									? 'user_id'
									: 'contact_id'
						]
					"
					autofocus
					tabindex="1"
					[searchStr]="otObjs.personObj ? otObjs.personObj.name : ''"
					[fuzzySearchableClasses]="
						permsService?.perms?.administrative
							? ['patients', 'contacts', 'sub_users']
							: ['patients']
					"
					(chosenEvent)="choosePatientOrContact($event)"
					(keyUp)="keyUpPatientOrContact($event)"
				>
				</app-gen-autocomplete>
			</div>
		</div>
		@if (followupserie.meeting_with == "meeting") {
			<div>
				<div class="d-flex">
					<div class="colstat-big">
						<app-gen-input
							[disabled]="isUpdateMode || isPastEvent"
							autocomplete="off"
							[actualObj]="followupserie"
							[errors]="errors"
							fieldName="meeting_title"
							tabindex="-1"
							[title_ph_lang]="
								followupserie.followuptype_id === 5
									? 'vacation_title'
									: 'meeting_title'
							"
							(keyupEvent)="validateEntireForm()"
						/>
					</div>
				</div>
			</div>
		}
		@if (
			permsService?.perms?.financial_documents &&
			!isPastAddition &&
			!isPastEvent
		) {
			<button
				[disabled]="
					(!followupserie.patient_id &&
						!followupserie.contact_id &&
						!followupserie.user_id) ||
					isPastEvent
				"
				class="btn btn-primary btn-icon mis-auto"
				titleLang="invoice_short"
				(click)="addInvoice(followupserie)"
				tabindex="-1"
				preIcon="invoice-plus"
				isImg
			>
				<!-- <div class="text">
					{{ "invoice_short" | langVal }}
				</div> -->
			</button>
		}

		@if (followupserie.is_new_patient_or_contact == "yes") {
			<div class="d-flex flex-grow-1">
				<div class="flex-grow-1">
					<app-gen-input
						autocomplete="off"
						[actualObj]="followupserie"
						[errors]="errors"
						fieldName="name"
						[disabled]="isPastEvent"
						(keyupEvent)="validateEntireForm()"
					/>
				</div>
			</div>
		}
		@if (
			!followupserie.patient_id &&
			!followupserie.contact_id &&
			!followupserie.user_id
		) {
			@if (
				(permsService?.perms?.administrative ||
					permsService?.perms?.add_new_patient) &&
				followupserie.meeting_with != "meeting" &&
				!isUpdateMode
			) {
				<div>
					<button
						class="btn btn-icon"
						[disabled]="isPastEvent"
						titleLang="add_patient"
						(click)="addPatient()"
						[icon]="
							followupserie.is_new_patient_or_contact == 'yes'
								? 'minus'
								: 'plus'
						"
					></button>

					<button
						class="btn btn-icon open-patient-form"
						(click)="openPatientForm()"
						titleLang="add_patient_extra"
						icon="insert-circle"
						isImg
					></button>
				</div>
			}
			@if (
				followupserie.is_new_patient_or_contact == "no" &&
				followupserie.followuptype_id != 5
			) {
				<div class="button-group duo mis-auto">
					<button
						[disabled]="isUpdateMode || isPastEvent"
						titleLang="patient_or_contact"
						class="btn btn-default"
						[class.btn-primary]="followupserie.meeting_with != 'meeting'"
						tabindex="-1"
						(click)="updFollowupserie('meeting_with', 'patient')"
					>
						{{ "patient_or_contact" | langVal }}
					</button>

					<button
						[disabled]="isUpdateMode || isPastEvent"
						[class.btn-primary]="followupserie.meeting_with == 'meeting'"
						class="btn btn-default"
						tabindex="-1"
						(click)="updFollowupserie('meeting_with', 'meeting')"
					>
						{{ "other_meeting" | langVal }}
					</button>
				</div>
			}
			@if (followupserie.is_new_patient_or_contact == "yes") {
				<div class="button-group mis-auto">
					<!--          <label>{{ "add_new" | langVal }}</label>-->
					<button
						class="btn btn-default"
						(click)="updNewPersonType('patient')"
						titleLang="patient"
						tabindex="-1"
						[disabled]="isPastEvent"
						[class.btn-primary]="
							followupserie.meeting_with == 'patient' &&
							followupserie.is_group == 'no'
						"
					>
						{{ "patient" | langVal }}
					</button>

					<button
						class="btn btn-default"
						(click)="updNewPersonType('patient', true)"
						titleLang="group_short"
						tabindex="-1"
						[disabled]="isPastEvent"
						[class.btn-primary]="
							followupserie.meeting_with == 'patient' &&
							followupserie.is_group == 'yes'
						"
					>
						{{ "group_short" | langVal }}
					</button>

					<button
						class="btn btn-default"
						(click)="updNewPersonType('contact')"
						titleLang="contact"
						tabindex="-1"
						[disabled]="isPastEvent"
						[class.btn-primary]="followupserie.meeting_with == 'contact'"
					>
						{{ "contact" | langVal }}
					</button>
				</div>
			}
		}
		@if (
			permsService.owner_has_users &&
			permsService?.perms?.administrative &&
			followupserie.followuptype_id == 5
		) {
			<div class="mis-auto">
				<app-gen-button-group
					[actualObj]="followupserie"
					fieldName="vacation_all_users"
					optionsListName="vacation_all_users_no_opts"
					(changeEvent)="chVacationIsAll()"
					[errors]="errors"
					[disabled]="isUpdateMode"
				/>
			</div>
		}
	</div>

	@if (
		!followupserie.patient_id &&
		!followupserie.contact_id &&
		!followupserie.user_id
	) {
		<div class="d-flex gap-3">
			@if (followupserie.is_new_patient_or_contact == "yes") {
				<div class="colstat-big show-one-more">
					<app-gen-input
						autocomplete="off"
						[actualObj]="followupserie"
						[errors]="errors"
						fieldName="new_phone_input"
						title_ph_lang="add_contactway"
						[disabled]="isPastEvent"
					/>
					<app-gen-input
						autocomplete="off"
						[actualObj]="followupserie"
						[errors]="errors"
						fieldName="new_phone_input2"
						title_ph_lang="add_contactway"
						[disabled]="isPastEvent"
					/>
				</div>
				<div class="switch-btn switch-btn-subtle">
					<app-yes-no
						(onClick)="handleNotifiyChange()"
						[isCheck]="followupserie.notifiy == 'yes'"
					/>
					<label (click)="handleNotifiyChange()">
						{{ "notifiy" | langVal }}
					</label>
				</div>

				@if (permsService?.perms?.administrative) {
					<div style="flex: 1 0 170px">
						<app-gen-autocomplete
							title_ph_lang="payor"
							[actualObj]="followupserie"
							fieldName="payor_id"
							tabindex="-1"
							[fuzzySearchableClasses]="['payors']"
							[disabled]="isPastEvent"
						/>
					</div>
				}
			}
		</div>
	}
</div>

@if (
	followupserie.followuptype_id == 1 &&
	["patient", "user"].includes(followupserie.meeting_with)
) {
	<div class="d-flex justify-content-between meeting-options">
		<div class="colstat-big">
			<label>{{ "meetingtype" | langVal }}</label>
			<app-gen-autocomplete
				#meetingtypeFuzzyInput
				title_ph_lang="meetingtype"
				[searchStr]="otObjs.meetingObj ? otObjs.meetingObj.name : ''"
				onClickClearAndShowOpts
				[disabled]="isPastEvent"
				tabindex="-1"
				[fuzzySearchableClasses]="['meetingtypes']"
				[error]="errors.meetingtype_id"
				(chosenEvent)="chooseMeetingtype($event)"
				(keyUp)="keyUpMeetingType($event)"
				inputmode="none"
				[hasPlus]="permsService?.perms?.administrative && !isPastEvent"
				plusLang="add_meetingtype"
				(plusClick)="openAddMeetingtypeModal()"
			/>
		</div>
	</div>
}
@if (
	permsService.owner_has_users &&
	(permsService?.perms?.administrative ||
		permsService?.perms?.assign_sub_users) &&
	(followupserie.followuptype_id != 5 ||
		followupserie.vacation_all_users == "no") &&
	!only_therapist_id &&
	followupserie.contact_id &&
	show_is_assoc
) {
	<div class="d-flex">
		<div class="colstat-big">
			<app-gen-button-group
				[actualObj]="followupserie"
				fieldName="is_assoc"
				optionsListName="is_assoc_no_opts"
				[disabled]="isUpdateMode"
				tabindex="-1"
				(changeEvent)="changeIsAssoc()"
			/>
		</div>
	</div>
}

@if (!only_therapist_id || locations_only) {
	<!-- permsService?.perms?.assign_sub_users -->
	<div
		class="d-flex gap-3"
		style="
			padding-bottom: 10px;
			margin-bottom: 10px;
			border-bottom: 1px solid var(--light-green);
		"
	>
		@if (
			permsService.owner_has_users &&
			(permsService?.perms?.administrative ||
				permsService?.perms?.assign_sub_users) &&
			(followupserie.followuptype_id != 5 ||
				followupserie.vacation_all_users == "no") &&
			!only_therapist_id &&
			followupserie.is_assoc == "yes"
		) {
			<div class="colstat-big colstat">
				<label>{{ "therapist" | langVal }}</label>
				@if (search_by_tags_add_meeting) {
					@if (filterSubUsersOpen) {
						<app-autocomplete-with-tags
							(chosenEvent)="chooseTagsForUsers($event)"
							title_ph_lang="filter_sub_users"
							class="meeting-filter"
							#subUsersAC
						/>
					} @else {
						<button
							titleLang="filter_sub_users"
							class="btn btn-icon"
							(click)="openFilterSubUsers()"
							icon="filter"
						></button>
					}
				}
				@if (isUpdateMode) {
					<app-autocomplete-with-tags
						isStatic
						[objs]="sub_user_objs"
						[error]="errors.assoc_sub_user_ids"
						[excludeIds]="userExcludeIds"
					/>
				} @else {
					<app-autocomplete-with-tags
						#subUsersFuzzyInput
						(chosenEvent)="updateSubUsers($event)"
						title_ph_lang="therapist"
						[fuzzySearchableClasses]="['sub_users', 'sub_user_groups']"
						[error]="errors.assoc_sub_user_ids"
						[objs]="sub_users"
						tabindex="2"
						[isLoading]="loadingSubUsers"
						[excludeIds]="userExcludeIds"
						[noInput]="
							followupserie.followuptype_id == 5 &&
							followupserie.assoc_sub_user_ids.length != 0
						"
					/>
				}
			</div>
		}
		@if (followupserie.followuptype_id != 5 && ownerHasUsers) {
			<div class="colstat-big colstat">
				@if (!only_therapist_id || locations_only) {
					<!-- <div class="d-flex"> -->
					<label>{{ "location" | langVal }}</label>
					<!-- <div class="colstat-big"> -->
					@if (search_by_tags_add_meeting) {
						@if (filterLocationsOpen) {
							<app-autocomplete-with-tags
								(chosenEvent)="chooseTagsForLocations($event)"
								title_ph_lang="filter_locations"
								class="meeting-filter"
								#locationsAC
							/>
						} @else {
							<button
								titleLang="filter_locations"
								class="btn btn-icon"
								(click)="openFilterLocations()"
								icon="filter"
							></button>
						}
					}
					<app-gen-autocomplete
						#locationFuzzyInput
						title_ph_lang="location"
						onClickClearAndShowOpts
						tabindex="3"
						[searchStr]="otObjs.locationObj ? otObjs.locationObj.name : ''"
						[disabled]="isPastEvent"
						[fuzzySearchableClasses]="['locations']"
						[approvedIds]="locationApprovedIds"
						[error]="errors.location_id"
						(chosenEvent)="chooseLocation($event)"
						(keyUp)="keyUpLocation($event)"
						[hasPlus]="permsService?.perms?.administrative"
						plusLang="add_location"
						(plusClick)="openAddLocationModal()"
					/>
					@if (locationWarning) {
						<p class="error">{{ locationWarning }}</p>
					}
					<!-- </div> -->
					<!-- </div> -->
				}
			</div>
			<div class="colstat-big">
				@if (!only_therapist_id) {
					@if (followupserie.meeting_with | inArray: ["patient", "user"]) {
						<label>{{ "tarif" | langVal }}</label>
						<!-- <div class="colstat-big"> -->
						<app-gen-autocomplete
							#tarifFuzzyInput
							title_ph_lang="tarif"
							tabindex="4"
							[disabled]="isPastEvent"
							[searchStr]="otObjs.tarifObj ? otObjs.tarifObj.name : ''"
							onClickClearAndShowOpts
							(keyUp)="keyUpTarif($event)"
							[fuzzySearchableClasses]="['tarifs']"
							(chosenEvent)="chooseTarif($event)"
							[error]="errors.tarif_id"
							[hasPlus]="permsService?.perms?.administrative"
							plusLang="add_tarif"
							(plusClick)="openAddTarifModal()"
						/>
						<!-- </div> -->
					}
				}
			</div>
		}
	</div>
}

<div class="d-flex gap-3">
	<div class="colstat-small">
		<label>{{ "date" | langVal }}</label>
		<app-date-picker
			[actualObj]="followupserie"
			#datePicker
			[errors]="errors"
			fieldName="followupserie_date"
			title_ph_lang="day"
			tabindex="-1"
			[disabled]="isPastEvent || (isDatePast && isInVac)"
			(changeEvent)="updFollowupserieAlt('followupserie_date')"
		/>
		<!--      [addonObject]="{after:{icon:'calendar'}}"-->
		@if (locationWarning && only_therapist_id) {
			<p class="error">{{ locationWarning }}</p>
		}
	</div>

	<div class="colstat-time">
		<label>{{ "time" | langVal }}</label>
		<!--    @if (eventsService.isMobile) {-->
		<!--      <app-gen-input-->
		<!--        autocomplete="off"-->
		<!--        [actualObj]="followupserie"-->
		<!--        [errors]="errors"-->
		<!--        fieldName="followupserie_time"-->
		<!--        [disabled]="isPastEvent"-->
		<!--        tabindex="-1"-->
		<!--        type="time"-->
		<!--        step="300"-->
		<!--        (keyupEvent)="-->
		<!--					updateIsFusInVac(); suggestLocation(); validateEntireForm()-->
		<!--				"-->
		<!--      />-->
		<!--     } @else {-->
		<!--         <app-time-picker2-->
		<!--           #timePicker-->
		<!--           [actualObj]="followupserie"-->
		<!--           (changeEvent)="updFollowupserieAlt('followupserie_time')"-->
		<!--           [disabled]="isPastEvent"-->
		<!--           [errors]="errors"-->
		<!--           fieldName="followupserie_time"-->
		<!--           title_ph_lang="time"-->
		<!--           tabindex="5"-->
		<!--         />-->

		<app-time-picker
			#timePicker
			[actualObj]="followupserie"
			(changeEvent)="updFollowupserieAlt('followupserie_time')"
			[disabled]="isPastEvent"
			[errors]="errors"
			fieldName="followupserie_time"
			title_ph_lang="time"
			tabindex="5"
		/>
		<!--     }-->
		<!--      [addonObject]="{after:{icon:'time'}}"-->

		<!--      [addonObject]="{after:{text:('min' |      langVal)}}"-->
	</div>
	@if (followupserie.followuptype_id != 5) {
		<div class="colstat-extra-small">
			<label>{{ "length" | langVal }}</label>
			<app-gen-input
				autocomplete="off"
				[actualObj]="followupserie"
				[errors]="errors"
				fieldName="length"
				[disabled]="isPastEvent"
				tabindex="-1"
				isNumber
				(keyupEvent)="
					updateIsFusInVac(); suggestLocation(); validateEntireForm()
				"
			/>
			<!--      [addonObject]="{after:{text:('min' |      langVal)}}"-->
		</div>
	}
</div>

@if (followupserie.followuptype_id == 5) {
	<div class="d-flex vacation-end">
		<div class="colstat colstat-small">
			<label>{{ "date_to" | langVal }}</label>
			<app-date-picker
				[disabled]="isPastEvent && !isVacPastEdit"
				[actualObj]="followupserie"
				[errors]="errors"
				fieldName="followupserie_date_to"
				title_ph_lang="date_to"
				tabindex="6"
				(changeEvent)="updFollowupserieAlt('followupserie_date_to')"
			/>
			<!--      [addonObject]="{after:{icon:'calendar'}}"-->
		</div>
		<div class="colstat colstat-time">
			<label>{{ "time_to" | langVal }}</label>
			<app-time-picker
				#timeToPicker
				[actualObj]="followupserie"
				[disabled]="isPastEvent && !isVacPastEdit"
				[errors]="errors"
				tabindex="7"
				fieldName="followupserie_time_to"
				title_ph_lang="time_to"
				(changeEvent)="updFollowupserieAlt('followupserie_time_to')"
			/>
			<!--      [addonObject]="{after:{icon:'time'}}"-->
		</div>
	</div>
} @else {
	<div class="d-flex gap-3 my-3">
		<div>
			<label>{{ "frequency" | langVal }}</label>
			<div titleLang="frequency">
				<!-- <button  [disabled]="(isUpdateMode && followupserie.change_series!='now_on') || isPastEvent" -->
				<!-- @for (repeatOption of repeatOptions; track repeatOption) {
          <button [disabled]="isPastEvent" tabindex="-1" [id]="'repeat_'+repeatOption"
                  (click)="updFollowupserie('series_repeat',repeatOption)" class="btn btn-default"
                  [class.btn-primary]="followupserie.series_repeat==repeatOption">{{ repeatOption | langVal }}
          </button>
        } -->
				<app-gen-button-group
					[disabled]="isPastEvent"
					[actualObj]="followupserie"
					fieldName="series_repeat"
					[options]="repeatOptionsNV()"
					title_ph_lang="period"
					(changeEvent)="
						updFollowupserie('series_repeat', followupserie.series_repeat)
					"
				/>
			</div>
			@if (isInVac && followupserie.followuptype_id != 5) {
				<div class="error">{{ "meeting_on_holiday_add_edit" | langVal }}</div>
			}
		</div>
		@if (followupserie.series_repeat != "one_time") {
			<div class="d-flex gap-3">
				<div class="colstat-small">
					<label>{{ "end_date" | langVal }}</label>
					<app-date-picker
						[actualObj]="followupserie"
						[errors]="errors"
						fieldName="series_limit_date"
						title_ph_lang="forever"
						tabindex="-1"
						[disabled]="isPastEvent || isUpdateMode"
						(changeEvent)="updFollowupserieAlt('series_limit_date')"
					/>
					<!--          [addonObject]="{after:{text:('ends_at' | langVal)}}"-->
				</div>
				@if (isUpdateMode) {
					<div>
						<button
							class="btn btn-primary pad-btns"
							tabindex="-1"
							(click)="modalProps = { name: 'change-limit-date' }"
						>
							{{ "change_limit_date" | langVal }}
						</button>
					</div>
				}
			</div>
		}
	</div>

	<div
		class="d-flex gap-3 meeting-options"
		style="flex-flow: row wrap"
	>
		@if (
			followupserie.meeting_with == "patient" &&
			(permsService?.perms?.clinic_financial ||
				permsService?.perms?.administrative)
		) {
			<div class="colstat-price">
				<label>{{ "price" | langVal }}</label>
				<app-gen-input
					isNumber
					autocomplete="off"
					[actualObj]="followupserie"
					[errors]="errors"
					fieldName="price"
					tabindex="-1"
					[disabled]="isPastEvent || !permsService?.perms?.administrative"
					(keyupEvent)="validateEntireForm()"
				/>
				<!--      [addonObject]="{after:{text:('price' | langVal)}}"-->
			</div>
		}

		@if (followupserie.followuptype_id == 1) {
			<div class="pad-btns">
				<app-gen-button-group
					[actualObj]="followupserie"
					fieldName="charged"
					optionsListName="chargeOpts"
					tabindex="-1"
					(changeEvent)="validateEntireForm()"
					[disabled]="isPastEvent || !permsService?.perms?.administrative"
				/>
			</div>
			<div class="pad-btns mis-auto">
				<app-gen-button-group
					[actualObj]="followupserie"
					fieldName="takes_place"
					optionsListName="takesPlaceOpts"
					[disabled]="isPastEvent || !permsService?.perms?.administrative"
					tabindex="-1"
					(changeEvent)="validateEntireForm()"
				/>
			</div>
		}
	</div>
}
@if (!isUpdateMode || followupserie.notes) {
	<div class="col-12 pb-3">
		<label>{{
			(followupserie.followuptype_id === 5 ? "vacation_notes" : "notes")
				| langVal
		}}</label>
		<app-gen-input
			[disabled]="isUpdateMode || isPastEvent"
			type="textarea"
			[title_ph_lang]="
				followupserie.followuptype_id === 5 ? 'vacation_notes' : 'notes'
			"
			[actualObj]="followupserie"
			[errors]="errors"
			fieldName="notes"
			tabindex="-1"
		>
		</app-gen-input>
	</div>
}
@if (isUpdateMode) {
	<div class="change-series-wrapper">
		@if (
			isPastEvent &&
			followupserie.followuptype_id !== 5 &&
			!followupserie.contact_id &&
			followupserie.meeting_with !== "meeting"
		) {
			<div class="change-series-title">
				{{ "no_change_in_followups" | langVal }}
			</div>
		}
		@if (
			!changedSeriesRepeatOnUpdate &&
			(followupserie.series_repeat != "one_time" || isPastEvent)
		) {
			<div>
				<label
					>{{
						(isPastEvent ? "to_delete" : "to_update_delete") | langVal
					}}:</label
				>
				<div>
					<app-gen-button-group
						[actualObj]="followupserie"
						fieldName="change_series"
						[options]="change_series_opts"
						(changeEvent)="handleChangeSeriesChange()"
						[errors]="errors"
					/>
				</div>
			</div>
		}

		<div class="d-flex">
			@if (
				followupserie.change_series == "until_date" &&
				followupserie.series_repeat != "one_time"
			) {
				<div class="colstat-small-double">
					<label>{{ "until_date" | langVal }}:</label>
				</div>
				<div class="col-8 col-lg-3">
					<app-date-picker
						#untilDatePicker
						[actualObj]="followupserie"
						fieldName="followupserie_until_date"
						[errors]="errors"
						title_ph_lang="until_date"
						(changeEvent)="validateEntireForm()"
					>
						<!--        [addonObject]="{after:{icon:'calendar'}}"-->
					</app-date-picker>
				</div>
				<!-- <div class="col-lg-1 ">

          </div> -->
			}
			<!-- <div class="col-2  col-lg-1">
          <label>{{ "message" | langVal }}:</label>
        </div>
        <div class="col-10  col-lg-3">
          <app-gen-input [actualObj]="followupserie"
                         fieldName="followupserie_du_message" title_ph_lang="message" disabled>
          </app-gen-input>
        </div> -->
		</div>

		@if (
			followupserie.meeting_with !== "meeting" && !followupserie.contact_id
		) {
			<div>
				<div>
					<label>{{ "add_remarks" | langVal }}:</label>
				</div>
				<div>
					<app-gen-input
						[actualObj]="followupserie"
						tabindex="35001"
						fieldName="followupserie_du_remarks"
						[errors]="errors"
						(keyupEvent)="validateEntireForm()"
						title_ph_lang="remarks"
					>
					</app-gen-input>
				</div>
			</div>
		}
	</div>
}
@if (!isPastEvent && isPastAddition) {
	<div class="error">
		{{ "is_past_addition_title" | langVal }}
	</div>
}
@if (!permsService?.perms?.administrative && errors.assoc_sub_user_ids) {
	<div>
		<p class="error">{{ errors.assoc_sub_user_ids }}</p>
	</div>
}

@if (siteDataLoaded) {
	<div>
		@if (
			permsService.owner_has_users &&
			followupserie.followuptype_id != 5 &&
			permsService?.perms?.administrative &&
			isUpdateMode &&
			isTodayOrLater
		) {
			<div class="btn-bottom">
				<button
					class="btn btn-primary"
					(click)="openSwitchLocation()"
				>
					{{ "switch_locations" | langVal }}
				</button>
				@if (switchLocationOpen) {
					<div>
						<app-spin-or-content [isSpin]="switchLocationSpinner">
							@for (locationRow of switchLocationRows; track locationRow) {
								<div
									(click)="flipLocation(locationRow)"
									class="link-locations"
									preIcon="bars"
								>
									{{ locationRow.location?.name }} {{ locationRow.assocUsers }}
								</div>
							} @empty {
								<div>{{ "no-locations_at_this_time" | langVal }}</div>
							}
						</app-spin-or-content>
					</div>
				}
			</div>
		}
	</div>
}

<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	@if (meeting_request) {
		<button
			titleLang="deactivate_meeting_request"
			class="btn btn-danger"
			(click)="deactivateMR()"
			[spinner]="deactivateSpin"
			[disabled]="deactivateSpin"
		>
			{{ "deactivate_meeting_request" | langVal }}
		</button>
	}

	@if (followup) {
		<app-btn-ext
			text="followup"
			[isSpin]="fetchingFollowup"
			(clickEv)="openFollowupEditModal()"
		/>
	}

	@if (btns.duplicate) {
		<button
			titleLang="duplicate"
			class="btn btn-danger"
			tabindex="11"
			(click)="preUpdate('duplicate')"
			[disabled]="isPastEvent || !isFormSubmittable"
		>
			{{ "duplicate" | langVal }}
		</button>
	}

	@if (isUpdateMode) {
		<app-btn-ext
			[text]="isDeletedDisabled ? 'delete_forbidden' : 'delete'"
			btnClass="danger"
			(clickEv)="preUpdate('delete')"
			[disabled]="!isFormSubmittable || isDeletedDisabled"
			[isSpin]="isSaving === 'delete'"
		/>

		<button
			titleLang="update"
			class="btn btn-primary"
			tabindex="9"
			[class.save-on-vac]="isInVac"
			[disabled]="
				!isFormSubmittable ||
				(isPastEvent && !isVacPastEdit) ||
				!isFormSubmittableWithOrig ||
				isSaving === 'save'
			"
			(click)="preUpdate('update')"
			tabClick
			[spinner]="isSaving === 'save'"
		>
			{{ "update" | langVal
			}}{{ isInVac ? ("meeting_on_holiday" | langVal) : "" }}
		</button>
	} @else {
		<button
			titleLang="add"
			class="btn btn-primary"
			tabindex="9"
			[class.save-on-vac]="isInVac"
			[disabled]="!isFormSubmittable || isSaving === 'save'"
			(click)="preSave()"
			tabClick
			[spinner]="isSaving === 'save'"
		>
			{{ "add" | langVal }}{{ isInVac ? ("meeting_on_holiday" | langVal) : "" }}
		</button>
	}
</div>

@switch (modalProps?.name) {
	@case ("add-invoice") {
		<app-add-invoice
			(onClose)="onClose.emit()"
			[description]="modalProps.description"
			[paid_by]="otObjs.personObj.name"
			[resource]="followupserie.meeting_with"
			[resourceId]="followupserie[followupserie.meeting_with + '_id']"
		/>
	}
	@case ("change-limit-date") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="change_limit_date"
			modalWrapperClass="modal-narrow-width"
		>
			<app-change-limit-date
				(onClose)="modalProps = null; handleChangeLimitDateClose($event)"
				[fus_id]="followupserie.id"
				[series_limit_date]="followupserie.series_limit_date"
			/>
		</app-modal-wrap>
	}
	@case ("home-meeting") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			[title]="
				('edit_followup' | langVal) +
				' ' +
				modalProps.user?.name +
				' - ' +
				(modalProps.followup.date | dateFormat)
			"
			hasExit
		>
			<app-home-meeting
				(onClose)="modalProps = null; onClose.emit()"
				[followup]="modalProps.followup"
				isModalMode
			/>
		</app-modal-wrap>
	}
	@case ("insert-patient-form") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="insert_patient_form"
			modalWrapperClass="modal-800"
		>
			<app-insert-patient-form
				(onClose)="modalProps = null; handleInsertPatientClose($event)"
				[inputObj]="modalProps.inputObj"
			/>
		</app-modal-wrap>
	}
	@case ("add-meetingtype") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="meetingtypes"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="
					modalProps = null; $event && handleAddMeetingtypeClose($event)
				"
				tableName="meetingtypes"
				[fuzzyName]="modalProps.fuzzyName"
			/>
		</app-modal-wrap>
	}
	@case ("add-location") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="locations"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; $event && handleAddLocationClose($event)"
				tableName="locations"
				[fuzzyName]="modalProps.fuzzyName"
			/>
		</app-modal-wrap>
	}
	@case ("add-tarif") {
		<app-modal-wrap
			(onClose)="modalProps = null; handleAddTarifClose($event)"
			title="tarifs"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; handleAddTarifClose($event)"
				tableName="tarifs"
				[fuzzyName]="modalProps.fuzzyName"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-overlap") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="you_have_overlaping_followupseries"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="modalProps = null"
				[freeText]="modalProps.message"
				avoidCancel
			/>
		</app-modal-wrap>
	}
	@case ("confirm-delete") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="the_followup_has_description"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="
					$event
						? handleDeleteConfirm(modalProps.response)
						: (modalProps = null)
				"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-duplicate") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="confirm_duplicate"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="modalProps = null; $event && handleDuplicateApprove()"
				[objectName]="modalProps.objectName"
			/>
		</app-modal-wrap>
	}
	@case ("patient") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			[title]="patient.name"
			modalWrapperClass="modal-1200"
		>
			<app-patient
				(onClose)="modalProps = null"
				[patient]="patient"
			/>
		</app-modal-wrap>
	}
	@case ("patient-followup") {
		<app-modal-wrap
			(onClose)="onClose.emit()"
			[title]="modalProps.patient.name + ' ' + (followup?.date | dateFormat)"
			modalWrapperClass="modal-1200"
		>
			<app-patient
				(onClose)="onClose.emit()"
				[patient]="modalProps.patient"
				[followup]="followup"
				isHomeMeetingOnly
			/>
		</app-modal-wrap>
	}
}
